/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { CoreNetworking } from '@airasia-rn/ui';

import { FetchLowFareResponse, QueryType } from '../types/lowFare.types';
import EnvironmentURLs, { parseEnv } from '../util/EnvironmentURLs';
import { replaceComWithCn } from '../util/utils';

declare const __DEV__: boolean;

export type Environment = 'stg' | 'prd';

export class LowFareApiService {
  constructor(
    private environment: Environment,
    private geoId: string,
  ) {}

  private getlowfareUrl(): string {
    return replaceComWithCn(
      this.geoId,
      EnvironmentURLs.LFC[parseEnv(this.environment)],
    );
  }

  async fetchLowFare(
    queryParams: QueryType,
    channelHash?: string,
    authToken?: string,
    userType?: string,
  ): Promise<FetchLowFareResponse> {
    const url = this.getlowfareUrl();

    const lowFareQueryParams = new URLSearchParams(
      Object.entries(queryParams).reduce(
        (acc, [key, value]) => {
          if (value !== undefined && value !== null && key !== 'range') {
            acc[key] = String(value);
          }
          return acc;
        },
        {} as Record<string, string>,
      ),
    ).toString();

    try {
      const response = await CoreNetworking.get(
        `${url}?${lowFareQueryParams}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            channel_hash: channelHash ?? '',
            'User-Type': userType ?? '',
          },
        },
      );
      const data = await response?.data;
      return data;
    } catch (err) {
      // Callers (useLowFareRange/useLowFareMonths) already classify and track this error via
      // useLogger - this is local dev-only diagnostics, not production error reporting.
      if (__DEV__) {
        console.log('❌ [LowFareApi] Fetch ERROR:', err);
      }
      throw err;
    }
  }
}
